let globalZIndex = 10000;

export const useGlobalZIndex = () => ++globalZIndex;

export const setGlobalZIndex = (val: number) => {
  globalZIndex = val;
};
